import { useAuth } from '@/lib/auth/auth';
import { useWritableMarketMutation } from '@/features/market/useWritableMarketMutation';
import {
  applySavedVenueDealOptimisticUpdate,
  invalidateSavedVenueDealQueries,
  restoreSavedVenueDealSnapshot,
  toggleSavedVenueDealRequest,
} from '@/features/venues/deals/savedVenueDealMutation';
import type { VenuePublicDeal } from '@/lib/api/apiTypes';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useFeedDealMutations() {
  const request = useAuth((state) => state.request);
  const queryClient = useQueryClient();

  const toggleSaved = useWritableMarketMutation(
    useMutation({
      mutationFn: ({ deal }: { deal: VenuePublicDeal }) => toggleSavedVenueDealRequest(request, deal),
      onMutate: ({ deal }) => applySavedVenueDealOptimisticUpdate(queryClient, { deal }),
      onError: (_error, _variables, context) => {
        restoreSavedVenueDealSnapshot(queryClient, context);
      },
      onSettled: (_data, _error, { deal }) =>
        invalidateSavedVenueDealQueries(queryClient, deal.venue_id),
    })
  );

  return { toggleSaved };
}
